import http from "../../http-common";

class ConvergenceAnonymousFormSubmitService {
    postConvergenceAnonymousFormSubmitService(formBody: {}) {
        return http.post(`/anonymous-form-submit/convergence`, formBody);
    }
}

export default new ConvergenceAnonymousFormSubmitService();
